<template>
  <div id="app">
    <div id="forgetpwd">
      <div class="forget-head">
        <div class="forget-head-left">
          <img src="@/assets/images/icon/logo.png" class="login-logo" />
          乐龄管理平台
        </div>
        <div class="forget-head-r">
          已有账号，<router-link class="forget-text" :to="{name:'login'}">立即登录</router-link>
        </div>
      </div>
    </div>
    <div class="forget-center">
      <div class="forget-center-title">
        找回密码
      </div>
      <el-steps :active="step" simple>
        <div class="forget-pad"></div>
        <el-step title="验证身份" icon="el-icon-sequeence1" :class="step == 0?'seleted':''"></el-step>
        <el-step title="重置密码" :icon="step>=1?'el-icon-sequeence2':'el-icon-sequeence2off'" :class="step == 1?'seleted':''"></el-step>
        <el-step title="找回成功" :icon="step>=2?'el-icon-sequeence3':'el-icon-sequeence3off'" :class="step == 2?'seleted':''"></el-step>
        <div class="forget-pad"></div>
      </el-steps>
      <div class="forget-box" v-if="step == 0">
        <el-input placeholder="请输入手机号" v-model.trim="mobile" :prefix-icon="iconuser" @focus="changeIcon(0,'el-icon-user_sel')" @blur="changeIcon(0,'el-icon-user')" @input="checkSend()" clearable style="margin-bottom:20px">
        </el-input>
        <div class="invite-box clearfix">
          <el-input placeholder="请输入验证码" v-model.trim="mobilecode" :prefix-icon="iconinvite" @focus="changeIcon(2,'el-icon-invite_sel')" @blur="changeIcon(2,'el-icon-invite')" @input="checkStep1()" clearable class="checkinput">
          </el-input>
          <el-button type="primary" class="invite-img checkbtn" :disabled="checksend" @click="sendCode()">{{sendText}}</el-button>
        </div>
         
        <div :class="successmsg&&successmsg.length > 0?'error-msg success':'error-msg'">
          <i class="el-icon-successicon" v-if="successmsg&&successmsg.length > 0"></i>{{successmsg}}
          <i class="el-icon-error2" v-if="errormsg&&errormsg.length > 0"></i>{{errormsg}}
        </div>
        <div class="button-box">
          <el-button type="primary" :disabled="checkstep1" @click="goToStep(1)">
            下一步
            <i class="el-icon-loading" v-if="loading"></i>
          </el-button>
        </div>
      </div>
      <div class="forget-box" v-if="step == 1">
        <el-input :type="newpwdtype" placeholder="新密码" v-model.trim="newpwd" :minlength="6" :maxlength="20" clearable @blur="checkPwd2()" @input="checkPwd()" style="margin-bottom:20px">
          <i class="inputicon el-icon-showpwd" slot="append" @click="changeType1()"></i>
        </el-input>
        <el-input :type="renewpwdtype" placeholder="确认密码" v-model.trim="renewpwd" :minlength="6" :maxlength="20" clearable @blur="checkPwd3()" @input="checkPwd()">
          <i class="inputicon el-icon-showpwd" slot="append" @click="changeType2()"></i>
        </el-input>
        <div class="error-msg">
          <i class="el-icon-error2" v-if="errormsg2&&errormsg2.length > 0"></i>{{errormsg2}}
        </div>
        <div class="button-box">
          <el-button type="primary" :disabled="checkstep2" @click="goToStep(2)">
            下一步
            <i class="el-icon-loading" v-if="loading"></i>
          </el-button>
        </div>
      </div>
      <div class="forget-box" v-if="step == 2">
        <div class="forget-success">
          <i class="el-icon-successicon"></i>
          <div class="forget-success-text">新密码设置成功，请重新登录</div>
          <div class="forget-success-text2">
            页面将于
            <label class="timelabel">{{num}}s</label>
            后跳转至登录页面
          </div>
        </div>
        <div class="button-box">
          <el-button type="primary" :disabled="checkstep2" @click="goToStep(3)">
            下一步
            <i class="el-icon-loading" v-if="loading"></i>
          </el-button>
        </div>
      </div>
    </div>
    <!--<div class="bottom-prompt">Copyright 2017-2018VIP.COM,All Rights Reserved ICP证：闽 XXXXXXXX</div>-->
  </div>
</template>

<script>
  export default {
    name: "",
    data(){
      return {
        step:0,
        type:2,
        checkid:null,
        iconuser:"el-icon-user",
        iconpwd:"el-icon-pwd",
        iconinvite:"el-icon-invite",
        checkstep1:true,
        checkstep2:true,
        checksend:true,
        newpwdtype:"password",
        renewpwdtype:"password",
        newpwd:"",
        renewpwd:"",
        num:5,
        loading:false,
        errormsg:null,
        errormsg2:null,
        mobile:null,
        mobilecode:null,
        sendText:'获取验证码',
        successmsg:null,
        flag:false,
      }
    },
    mounted(){

    },
    methods:{
      changeIcon(type,text) {
        let me = this;
        switch (type) {
          case 0:
            me.iconuser = text;
            break;
          case 1:
            me.iconpwd = text;
            break;
          case 2:
            me.iconinvite = text;
            break;
        }
      },
      checkPwd(){
        let me = this;
        if(me.newpwd && me.newpwd.length >= 6 && me.newpwd.length <= 20 && me.renewpwd && me.renewpwd.length >= 6 && me.renewpwd.length <= 20){
          me.checkstep2 = false;
        }else {
          me.checkstep2 = true;
        }
      },
      checkPwd2(){
        let me = this;
        if(me.newpwd && me.newpwd.length >= 6 && me.newpwd.length <= 20){
          // if(me.renewpwd == me.newpwd){
          //   me.checkstep2 = false;
          // }else{
          //   me.$message.error("确认密码必须和新密码一致!");
          //   me.checkstep2 = true;
          // }
        }else {
          me.$message.error("新密码长度为6-20位");
          me.checkstep2 = true;
        }
      },
      checkPwd3(){
        let me = this;
        if(me.renewpwd && me.renewpwd.length >= 6 && me.renewpwd.length <= 20){
          if(me.renewpwd == me.newpwd){
            me.checkstep2 = false;
          }else{
            me.$message.error("确认密码必须和新密码一致!");
            me.checkstep2 = true;
          }
        }else {
          me.$message.error("确认密码长度为6-20位");
          me.checkstep2 = true;
        }
      },
      changeType1(){
        let me = this;
        if(me.newpwdtype == 'password'){
          me.newpwdtype = 'text';
        }else{
          me.newpwdtype = 'password'
        }
      },
      changeType2(){
        let me = this;
        if(me.renewpwdtype == 'password'){
          me.renewpwdtype = 'text';
        }else{
          me.renewpwdtype = 'password'
        }
      },
      async sendCode(){
        let me = this;
        me.checksend = true;
        me.errormsg = null;
        me.successmsg = null;
        me.sendText = 60 + 's';
        console.log(11);
        let res = await me.$userService.sendCode(me.mobile,2,'csdrlndx');
        if(res&&res['success']){
          me.successmsg = res['content']['msg'];
           me.checkid = res['content']['id'];
        }else{
          let errmsg = res['errmsg'];
          if(res['errmsg']){
            me.errormsg = errmsg;
          }else{
            me.errormsg = '发生异常，请稍后重试!';
          }
        }
        setTimeout(function () {
          me.countDown(60);
        },1000)
      },
      countDown(num){
        let me = this;
        if(num > 0){
          num = num - 1;
          me.sendText = num + 's';
          setTimeout(function () {
            me.countDown(num)
          },1000)
        }else{
          me.checksend = false;
          me.sendText = "获取验证码"
        }
      },
      checkStep1(){
        let me = this;
        if(me.mobile&&me.mobile.length > 0 && me.mobilecode && me.mobilecode.length > 0){
          me.checkstep1 = false;
        }else{
          me.checkstep1 = true;
        }
      },
      checkSend(){
        let me = this;
        if(me.mobile&&me.mobile.length == 11&&me.sendText == '获取验证码'){
          me.checksend = false;
        }else{
          me.checksend = true;
        }
        me.checkStep1();
      },
      async goToStep(number){
        let me = this;
        me.loading = true;
        let res = null;
        if(number == 1){
          res = await me.$userService.checkMobileCode(me.mobile,me.mobilecode,me.type);
          if(res&&res['success']){
            me.errormsg = null;
            me.step = number;
          }else{
            me.successmsg = null;
            //  me.step = 1;
            //  me.checkstep2=true;
            let errmsg = res['errmsg']
            if(res['errmsg']){
              me.errormsg = errmsg;
            }else{
              me.errormsg = '发生异常，请稍后重试!';
            }
          }
        }
        if(number == 2){
          res = await me.$userService.changePwd(me.mobile,me.newpwd,me.renewpwd,me.checkid,'2');
          if(res&&res['success']){
            me.step = number;
            me.flag = true; 
            me.countDownTime(5);
          }else{
            let errmsg = res['errmsg']
            if(res['errmsg']){
              me.errormsg2 = errmsg;
            }else{
              me.errormsg2 = '发生异常，请稍后重试!';
            }
          }
        }
        if(number == 3){
          me.flag = false;
          me.$router.push({name:'login'});
        }
        me.loading = false;
      },
      countDownTime(num) {
        let me = this;
        me.num = num;
        console.log(num);
        if(typeof num == 'number' && num > 0 && me.flag){
          num = num - 1;
          setTimeout(function () {
            me.countDownTime(num);
          },1000)
        }else{
          if(me.flag){
            me.$router.push({name:'login'});
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/css/icon.css';
  @import '../../assets/less/global.less';
  @import '../../assets/css/app.css';
  #app{
    background-color: #f9f9f9;
    #forgetpwd{
      padding: 0px 200px;
      background-color: #fff;
      .forget-head{
        height: 66px;
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        line-height:66px;
        .forget-head-left{
          float: left;
          .login-logo{
            width: 82px;
            height: 51px;
          }
        }
        .forget-head-r{
          float: right;
          font-size: 16px;
          font-weight: normal;
          color: #666666;
          .forget-text{
            text-decoration: underline;
            font-size: 16px;
            font-weight: normal;
            color: #418ce2;
          }
        }
      }
    }
    .forget-center{
      margin: 43px 200px 0;
      background-color: #fff;
      padding: 24px 37px;
      .forget-center-title{
        font-size: 26px;
        color: #666666;
      }
      .el-input-group__append{
        background-color: #fff;
      }
      .el-steps{
        padding: 0;
        background-color: #fff;
        display: flex;
        justify-content: center;
        .forget-pad{
          width: 180px;
          border-bottom: 1px solid #cdcdcd;
        }
        .el-step{
          height: 60px;
          width: 240px;
          border-bottom: 1px solid #cdcdcd;
          display: flex;
          justify-content: center;
          flex-basis: auto !important;
          &.seleted{
            border-bottom: 3px solid #3f80cc;
          }
          .el-step__head>.el-step__line{
            display: none;
          }
          .el-step__main{
            flex-grow: 0;
            align-items: center;
            .el-step__title{
              max-width: 100%;
              white-space: nowrap;
            }
            .el-step__arrow{
              display: none;
            }
          }
        }
      }
      .forget-box{
        margin:80px auto 0;
        width: 400px;
        padding: 0 20px;
        .forget-success{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .el-icon-successicon{
            width: 60px;
            height: 60px;
            margin-bottom: 30px;
          }
          .forget-success-text{
            font-size: 20px;
            color: #333333;
            margin-bottom: 24px;
          }
          .forget-success-text2{
            font-size: 16px;
            color: #666666;
            margin-bottom: 50px;
            .timelabel{
              color: #d01e0b;
            }
          }
        }
        .error-msg{
          &.success{
            color: #54c743;
          }
          .el-icon-successicon{
            width: 16px;
            height: 16px;
            margin-right: 10px;
          }
        }
      }
    }
    .bottom-prompt{
      font-size: 14px;
      color: #999999;
      margin-top: 30px;
      text-align: center;
    }
  }

</style>
<style lang="scss" scoped>
  html,body{
    height:100%;background-color: #f9f9f9;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Forgotpwd.vue